import { useState } from 'react'
import { settingsApi } from '../api'

/** Owns the SFTP password reset flow (request + revealed password state). */
export function useSftpPasswordReset() {
  const [resetting, setResetting] = useState(false)
  const [password, setPassword] = useState<string | null>(null)

  const reset = async () => {
    setResetting(true)
    setPassword(null)
    try {
      const res = await settingsApi.resetSftpPassword()
      setPassword(res.sftp_password)
    } catch {
      // leave password null — UI shows the masked placeholder
    } finally {
      setResetting(false)
    }
  }

  return { resetting, password, reset }
}
